var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"title":"Import form excel"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6 col-sm-6 col-md-6 col-lg-6"}),_c('div',{staticClass:"col-xs-6 col-sm-6 col-md-6 col-lg-6"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }